import React, { Component } from "react"
import { Index } from "elasticlunr"
import { Link } from "gatsby"
import Button from "../button-generic"
import Item from "../item"
import Utils from "../../utils"

const formFields = [
         {
           'title': "Cercador",
           'name': "s",
           'placeholder': "Digue'ns el que busques",
           'clearIcon': "icons-32-x-32-export-x",
           'iconSize': 32,
           'type': "text",
         }
 ]


// Search component
export default class ElasticSearch extends Component {

  constructor(props) {
    super(props)
    this.state = {
      query: ``,
      results: [],
      showIcon: false,
      buttonText: `Cercar a tota la web`
    }
  }



  handleSubmit = (e) => {
    e.preventDefault();
  }

  cleanSearch = () => {
    this.setState({
      query: ``,
      showIcon: false,
      results: []
    })
    //setShowIcon(false)
  }

  render() {

    const { buttonText, query, results } = this.state

    return (
      <div>
        {/* <input type="text" value={this.state.query} onChange={this.search} /> */}

        <form onSubmit={(e) => this.handleSubmit(e)}>
        {formFields.map((field, i) => {
          return (
            <label key={i} className="form-label">
                {!query
                ?
                <div
                  className="form-label-title Small-Bold-L---orange"
                >
                  {field.title}
                </div>
                :
                <div
                  className="form-label-title Small-Bold-L---orange"
                >
                  {results.length } resultats de cerca per: {query}
                </div>
                }


              <div className="form-group">
                <input
                  className="search H4-Light-L---black"
                  type={field.type}
                  name={field.name}
                  placeholder={field.placeholder}
                  value={this.state.query}
                  onChange={this.search}
                />
                {field.clearIcon && this.state.showIcon &&
                  <Button
                    className="clear-text"
                    iconClassName="icon"
                    iconSize={field.iconSize}
                    iconColor="bordeaux"
                    icon={field.clearIcon}
                    onClick={this.cleanSearch}
                    />
                }
              </div>
            </label>
          )
        })
        }
        {buttonText &&
          <div className="button-wrapper hide">
            <input type="submit" value={buttonText} />
          </div>
        }
        </form>

        <div className="search-results">
        <div className="row">
          {this.state.results.map((item, key) => {

            return (
              <React.Fragment key={key}>
                <Item
                  className="col-12 col-md-12 col-lg-12 m-b-34"
                  title={item?.title}
                  type={Utils.getType(item)}
                  description={Utils.getDescription(item)}
                  labelCta="Veure més"
                  path={Utils.getUrl(item)}
                  readmore={item.type === 'node--blog_post' ? "Llegir-ho" : "Veure més"}
                  icon={item.type === 'node--blog_post' ? "icons-32-x-32-generic-plus" : ""}
                  imageUrl={item?.image?.src["294x192"]}
                />
              </React.Fragment>
            )
          })}
        </div>
          {/*this.state.results.map(page => (
            <li key={page.id}>
              <Link to={"/" + page?.path?.alias}>{page?.title}</Link>
              {": " + page?.field_tag?.join(`,`)}
            </li>
          ))*/}
        </div>
      </div>
    )
  }
  getOrCreateIndex = () =>
    this.index
      ? this.index
      : // Create an elastic lunr index and hydrate with graphql query results
        Index.load(this.props.searchIndex)

  search = evt => {
    const query = evt.target.value
    this.index = this.getOrCreateIndex()
    this.setState({
      showIcon: true,
      query,
      // Query the index with search string to get an [] of IDs
      results: this.index
        .search(query, {})
        // Map over each ID and return the full document
        .map(({ ref }) => this.index.documentStore.getDoc(ref)),
    })
  }
}
